import { render } from "./edit-doctor.vue?vue&type=template&id=73e0f21c"
import script from "./edit-doctor.vue?vue&type=script&lang=js"
export * from "./edit-doctor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__